exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.itinerary{position:relative\n}\n@media (min-width:40em){\n.itinerary{border-bottom:1px solid #d5dde2;display:grid;grid-gap:20px;grid-template-columns:100px 1fr 200px;margin-bottom:45px;padding-bottom:45px\n}\n.itinerary input,.itinerary p,.itinerary select,.itinerary textarea{margin:0\n}\n.itinerary .editor{grid-column:span 2\n}\n}", ""]);

// exports
